module.exports = __webpack_public_path__ + "static/media/staff-avatar.fcf805a1.png";